// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2fgkA","header":"PatientBlock_header__2rBE8","label":"PatientBlock_label__V7U8l","option":"PatientBlock_option__3H7E1"};